/**
 * Bundle Cart Validator v2 - Always Fresh Validation
 * No caching - always validates to catch quantity changes
 */

(function () {
    'use strict';

    const CONFIG = {
        apiEndpoint: 'https://bop.lc-apps.dyndns.org/availability',
        debugMode: true
    };

    let isValidating = false;

    function log(...args) {
        if (CONFIG.debugMode) {
            console.log('[BundleValidator]', ...args);
        }
    }

    // Create/get error container
    function getErrorContainer() {
        let container = document.getElementById('bundle-validation-errors');

        if (!container) {
            container = document.createElement('div');
            container.id = 'bundle-validation-errors';
            container.style.cssText = `
        display: none;
        margin: 1rem 0 0 0;
        padding: 1.25rem;
        background: linear-gradient(135deg, #fefcfb 0%, #faf8f7 100%);
        border: 1px solid #e7e5e4;
        border-radius: 8px;
        color: #57534e;
        font-weight: normal;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        font-family: inherit;
        width: 100%;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 1.5;
      `;

            // Add enhanced styles for components
            const style = document.createElement('style');
            style.textContent = `
                .inventory-issues h4 {
                    color: #dc2626;
                    margin: 0 0 15px 0;
                    font-size: 16px;
                    font-weight: 600;
                    font-family: inherit;
                }
                
                .general-notice {
                    background: rgba(220, 38, 38, 0.05);
                    border: 1px solid rgba(220, 38, 38, 0.2);
                    border-radius: 6px;
                    padding: 10px 15px;
                    margin-bottom: 15px;
                }
                
                .general-notice p {
                    margin: 0;
                    color: #7f1d1d;
                    font-size: 13px;
                    font-weight: 400;
                    font-family: inherit;
                    line-height: 1.4;
                }
                
                .bundle-issues, .global-suggestions, .bundle-suggestions {
                    margin: 15px 0;
                }
                
                .bundle-issue, .global-suggestion, .bundle-suggestion {
                    background: white;
                    border-radius: 6px;
                    padding: 15px;
                    margin: 10px 0;
                    border-left: 3px solid #9ca3af;
                    border: 1px solid #e5e7eb;
                }
                
                .conflict-detail {
                    color: #dc2626;
                    font-style: normal;
                    font-size: 13px;
                    font-weight: 500;
                    margin-top: 6px;
                    padding: 4px 8px;
                    background: rgba(220, 38, 38, 0.05);
                    border-radius: 4px;
                    border-left: 2px solid #dc2626;
                }
                
                .suggestion-text {
                    display: inline-block;
                    margin-right: 10px;
                    flex: 1;
                    color: #6b7280;
                }
                
                .global-suggestion, .bundle-suggestion {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                
                .action-btn {
                    background: #ea580c;
                    color: white;
                    border: none;
                    padding: 10px 18px;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    font-weight: 500;
                    font-family: inherit;
                    text-transform: none;
                    letter-spacing: 0;
                }
                
                .action-btn:hover {
                    background: #dc2626;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(234, 88, 12, 0.3);
                }
                
                .action-btn:disabled {
                    background: #d1d5db;
                    cursor: not-allowed;
                    transform: none;
                    color: #9ca3af;
                }
                
                .success-message {
                    padding: 12px;
                    border-radius: 4px;
                    font-weight: 500;
                    background: #f0fdf4;
                    border: 1px solid #bbf7d0;
                    color: #166534;
                }
                
                .error-message {
                    padding: 12px;
                    border-radius: 4px;
                    font-weight: 500;
                    background: #fef2f2;
                    border: 1px solid #fecaca;
                    color: #dc2626;
                }
                
                .no-suggestions {
                    margin: 15px 0;
                    padding: 12px;
                    background: #f9fafb;
                    border-radius: 4px;
                    border: 1px solid #e5e7eb;
                }
                
                .no-suggestions p {
                    margin: 0;
                    color: #6b7280;
                    font-style: italic;
                }
                
                .conflict-group {
                    margin: 10px 0;
                    border: 1px solid #fecaca;
                    border-radius: 6px;
                    overflow: hidden;
                    box-shadow: 0 1px 3px rgba(220, 38, 38, 0.1);
                    background: white;
                }
                
                .conflict-group-header {
                    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
                    padding: 8px 15px;
                    border-bottom: 1px solid #fecaca;
                    font-weight: 500;
                    color: #7f1d1d;
                    font-family: inherit;
                    font-size: 13px;
                    line-height: 1.3;
                }
                
                .conflict-component {
                    color: #dc2626;
                    font-weight: 600;
                }
                
                .affected-bundles {
                    padding: 10px 15px;
                    background: white;
                }
                
                .affected-bundle {
                    padding: 4px 0;
                    border-bottom: 1px solid #f3f4f6;
                }
                
                .affected-bundle:last-child {
                    border-bottom: none;
                }
                
                .bundle-name {
                    font-weight: 500;
                    color: #374151;
                    font-size: 14px;
                    margin-bottom: 2px;
                    font-family: inherit;
                    line-height: 1.3;
                }
                
                .bundle-main-title {
                    font-weight: 500;
                    color: #374151;
                    font-size: 14px;
                    margin-bottom: 2px;
                    font-family: inherit;
                    line-height: 1.3;
                }
                
                .bundle-variation {
                    font-weight: 400;
                    color: #9ca3af;
                    font-size: 12px;
                    font-style: normal;
                    margin-bottom: 2px;
                    font-family: inherit;
                    line-height: 1.2;
                }
                
                .conflict-details {
                    font-size: 14px;
                    color: #6b7280;
                    margin-top: 4px;
                }
                
                .impact-preview {
                    background: #f0f9ff;
                    border: 1px solid #bae6fd;
                    border-radius: 4px;
                    padding: 8px 12px;
                    margin: 8px 0;
                    font-size: 14px;
                    color: #0369a1;
                }
                
                .quantity-context {
                    font-weight: 500;
                    color: #374151;
                }
                
                .quantity-change {
                    color: #dc2626;
                    font-weight: 600;
                }
                
                .suggestion-enhanced {
                    background: white;
                    border-radius: 6px;
                    padding: 15px;
                    margin: 10px 0;
                    border: 1px solid #e5e7eb;
                    border-left: 3px solid #3b82f6;
                }
                
                .suggestion-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 8px;
                }
                
                .suggestion-main {
                    flex: 1;
                    margin-right: 15px;
                }
                
                .suggestion-title {
                    font-weight: 500;
                    color: #374151;
                    margin-bottom: 4px;
                }
                
                .suggestion-impact {
                    font-size: 14px;
                    color: #059669;
                    font-style: italic;
                }
                
                /* Inline line item notifications */
                .line-item-status-indicator {
                    display: inline-flex;
                    align-items: center;
                    gap: 3px;
                    margin-left: 6px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 3px 8px;
                    border-radius: 12px;
                    vertical-align: middle;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    font-family: inherit;
                }
                
                .line-item-status-indicator.oversold {
                    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
                    color: #b91c1c;
                    border: 1px solid #f87171;
                    box-shadow: 0 1px 3px rgba(220, 38, 38, 0.2);
                }
                
                .line-item-status-indicator.limited {
                    background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%);
                    color: #c2410c;
                    border: 1px solid #fb923c;
                    box-shadow: 0 1px 3px rgba(234, 88, 12, 0.2);
                }
                
                .line-item-status-indicator.available {
                    background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
                    color: #166534;
                    border: 1px solid #4ade80;
                    box-shadow: 0 1px 3px rgba(5, 150, 105, 0.2);
                }
                
                .quantity-selector--oversold .quantity-selector__input {
                    border-color: #dc2626 !important;
                    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%) !important;
                    color: #b91c1c !important;
                    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;
                    font-weight: 600 !important;
                }
                
                .quantity-selector--oversold .quantity-selector__button {
                    border-color: #dc2626 !important;
                    color: #dc2626 !important;
                    background: rgba(220, 38, 38, 0.05) !important;
                }
                
                .quantity-selector--oversold .quantity-selector__button:hover {
                    background: #dc2626 !important;
                    color: white !important;
                }
                
                .quantity-selector--limited .quantity-selector__input {
                    border-color: #ea580c !important;
                    background: linear-gradient(135deg, #fef7f0 0%, #fed7aa 100%) !important;
                    color: #c2410c !important;
                    box-shadow: 0 0 0 3px rgba(234, 88, 12, 0.1) !important;
                    font-weight: 600 !important;
                }
                
                .quantity-selector--limited .quantity-selector__button {
                    border-color: #ea580c !important;
                    color: #ea580c !important;
                    background: rgba(234, 88, 12, 0.05) !important;
                }
                
                .quantity-selector--limited .quantity-selector__button:hover {
                    background: #ea580c !important;
                    color: white !important;
                }
                
                .line-item-inline-notification {
                    margin-top: 12px;
                    padding: 12px 16px;
                    border-radius: 8px;
                    font-size: 13px;
                    line-height: 1.5;
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                    font-family: inherit;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                    border-left: 4px solid;
                }
                
                .line-item-inline-notification.error {
                    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
                    border-color: #dc2626;
                    color: #7f1d1d;
                    border-right: 1px solid #fecaca;
                    border-top: 1px solid #fecaca;
                    border-bottom: 1px solid #fecaca;
                }
                
                .line-item-inline-notification.warning {
                    background: linear-gradient(135deg, #fef7f0 0%, #fed7aa 100%);
                    border-color: #ea580c;
                    color: #9a3412;
                    border-right: 1px solid #fed7aa;
                    border-top: 1px solid #fed7aa;
                    border-bottom: 1px solid #fed7aa;
                }
                
                .line-item-inline-notification .notification-icon {
                    flex-shrink: 0;
                    margin-top: 2px;
                    font-size: 16px;
                    opacity: 0.8;
                }
                
                .line-item-inline-notification .notification-content {
                    flex: 1;
                }
                
                .line-item-inline-notification .notification-content strong {
                    font-weight: 600;
                    margin-bottom: 4px;
                    display: block;
                }
                
                .line-item-inline-notification .notification-actions {
                    display: flex;
                    gap: 10px;
                    margin-top: 8px;
                    flex-wrap: wrap;
                }
                
                .inline-action-btn {
                    background: rgba(255, 255, 255, 0.9);
                    color: inherit;
                    border: 1.5px solid currentColor;
                    padding: 6px 12px;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 12px;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    text-decoration: none;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    font-family: inherit;
                    text-transform: none;
                    letter-spacing: 0.3px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }
                
                .inline-action-btn:hover {
                    background: currentColor;
                    color: white;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
                }
                
                .inline-action-btn:active {
                    transform: translateY(0);
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }
            `;
            document.head.appendChild(style);

            // Insert right after the checkout button - Prestige theme optimized
            const cartRecap = document.querySelector('.cart-recap');
            const checkoutButton = document.querySelector('.cart-recap button[name="checkout"]') ||
                document.querySelector('.cart-recap .button') ||
                document.querySelector('button[name="checkout"]') ||
                document.querySelector('.cart__checkout-button');

            if (cartRecap && checkoutButton) {
                // Insert after the checkout button within cart-recap
                checkoutButton.parentNode.insertBefore(container, checkoutButton.nextSibling);
                log('Error container inserted after checkout button in cart-recap');
            } else if (checkoutButton) {
                // Insert after checkout button even if not in cart-recap
                checkoutButton.parentNode.insertBefore(container, checkoutButton.nextSibling);
                log('Error container inserted after checkout button (fallback)');
            } else {
                // Prestige theme fallbacks
                const target = document.querySelector('.cart-recap') ||
                    document.querySelector('.cart__footer') ||
                    document.querySelector('.cart') ||
                    document.querySelector('.cart__content') ||
                    document.body;

                if (target === document.querySelector('.cart-recap')) {
                    target.appendChild(container);
                    log('Error container appended to cart-recap');
                } else if (target.firstChild) {
                    target.insertBefore(container, target.firstChild);
                    log('Error container inserted at fallback location');
                } else {
                    target.appendChild(container);
                    log('Error container appended to fallback target');
                }
            }

            log('Error container created');
        }

        return container;
    }

    // Clear all inline notifications
    function clearInlineNotifications() {
        // Remove status indicators
        document.querySelectorAll('.line-item-status-indicator').forEach(el => el.remove());

        // Remove quantity field styling
        document.querySelectorAll('.quantity-selector').forEach(el => {
            el.classList.remove('quantity-selector--oversold', 'quantity-selector--limited');
        });

        // Remove inline notifications
        document.querySelectorAll('.line-item-inline-notification').forEach(el => el.remove());

        log('Cleared all inline notifications');
    }

    // Get all variant IDs currently in the cart
    function getCartVariantIds() {
        const variantIds = [];
        const allRows = document.querySelectorAll('tr[data-line-key]');
        allRows.forEach(row => {
            const lineKey = row.dataset.lineKey;
            if (lineKey) {
                const variantId = lineKey.split(':')[0];
                variantIds.push(variantId);
            }
        });
        log(`🛒 Found ${variantIds.length} variant IDs in cart:`, variantIds);
        return variantIds;
    }

    // Add inline notifications to line items
    function addInlineNotifications(validationResult) {
        if (!validationResult || !validationResult.bundle_validations) return;

        log('🔍 Adding inline notifications for validation result');
        log('📊 Bundle validations:', validationResult.bundle_validations.length);
        log('📊 Global suggestions:', validationResult.global_suggestions?.length || 0);

        // Get current cart variant IDs for reference
        const cartVariantIds = getCartVariantIds();

        // First, clear any existing notifications
        clearInlineNotifications();

        let notificationsAdded = 0;

        // Process each bundle validation
        validationResult.bundle_validations.forEach((bundle, index) => {
            log(`📦 Processing bundle ${index + 1}:`, bundle.bundle_title, 'Valid:', bundle.is_valid);
            if (!bundle.is_valid && bundle.primary_conflict) {
                log('❌ Adding notification for invalid bundle:', bundle.bundle_title);
                addLineItemNotification(bundle, validationResult);
                notificationsAdded++;
            }
        });

        // Also check for individual component issues from global suggestions
        if (validationResult.global_suggestions) {
            validationResult.global_suggestions.forEach((suggestion, index) => {
                log(`💡 Processing global suggestion ${index + 1}:`, suggestion.type);
                if (suggestion.type === 'reduce_individual' && suggestion.action_data.variant_id) {
                    log('⚠️ Adding component notification for variant:', suggestion.action_data.variant_id);
                    addComponentNotification(suggestion, validationResult);
                    notificationsAdded++;
                }
            });
        }

        log(`✅ Added ${notificationsAdded} inline notifications`);
    }

    // Find variant ID by matching bundle title to cart item names
    function findVariantIdByBundleTitle(bundleTitle) {
        log(`🔍 Looking for variant ID by matching bundle title: "${bundleTitle}"`);

        // Clean up the bundle title for matching
        const cleanTitle = bundleTitle.replace(/\s*-\s*[^-]*$/, '').trim(); // Remove size/variant info after last dash
        log(`🧹 Cleaned title for matching: "${cleanTitle}"`);

        // Look through all cart rows and check product names
        const allRows = document.querySelectorAll('tr[data-line-key]');
        for (const row of allRows) {
            const productLink = row.querySelector('a[href*="/products/"]');
            if (productLink) {
                const productName = productLink.textContent.trim();
                log(`🔍 Comparing "${cleanTitle}" with cart item "${productName}"`);

                // Try exact match first
                if (productName === cleanTitle) {
                    const lineKey = row.dataset.lineKey;
                    const variantId = lineKey.split(':')[0];
                    log(`✅ Exact match found! Variant ID: ${variantId}`);
                    return variantId;
                }

                // Try partial match (bundle title contains product name or vice versa)
                if (cleanTitle.includes(productName) || productName.includes(cleanTitle)) {
                    const lineKey = row.dataset.lineKey;
                    const variantId = lineKey.split(':')[0];
                    log(`✅ Partial match found! Variant ID: ${variantId}`);
                    return variantId;
                }

                // Try matching first few words
                const titleWords = cleanTitle.toLowerCase().split(' ').slice(0, 2);
                const nameWords = productName.toLowerCase().split(' ').slice(0, 2);
                if (titleWords.length >= 2 && nameWords.length >= 2 &&
                    titleWords[0] === nameWords[0] && titleWords[1] === nameWords[1]) {
                    const lineKey = row.dataset.lineKey;
                    const variantId = lineKey.split(':')[0];
                    log(`✅ Word match found! Variant ID: ${variantId}`);
                    return variantId;
                }
            }
        }

        log(`❌ Could not find variant ID for bundle title: "${bundleTitle}"`);
        return null;
    }

    // Find variant ID for a product by checking cart data or DOM
    function findVariantIdForProduct(productId) {
        log(`🔍 Looking for variant ID for product ${productId}`);

        // Strategy 1: Check product links in the DOM
        const productLink = document.querySelector(`a[href*="/products/"][href*="variant=${productId}"], a[href*="/products/"][href*="?variant=${productId}"]`);
        if (productLink) {
            const url = new URL(productLink.href);
            const variantId = url.searchParams.get('variant');
            if (variantId) {
                log(`✅ Found variant ID ${variantId} from product link`);
                return variantId;
            }
        }

        // Strategy 2: Look for product links and try to extract variant from cart data
        const allProductLinks = document.querySelectorAll(`a[href*="/products/"]`);
        for (const link of allProductLinks) {
            const href = link.href;
            if (href.includes(`variant=${productId}`)) {
                const match = href.match(/variant=(\d+)/);
                if (match) {
                    log(`✅ Found variant ID ${match[1]} from href analysis`);
                    return match[1];
                }
            }
        }

        // Strategy 3: The product ID might actually be the variant ID in some cases
        // Check if any cart rows have this as a variant ID
        const allRows = document.querySelectorAll('tr[data-line-key]');
        for (const row of allRows) {
            const lineKey = row.dataset.lineKey;
            if (lineKey) {
                const extractedVariantId = lineKey.split(':')[0];
                if (extractedVariantId === String(productId)) {
                    log(`✅ Product ID ${productId} is actually a variant ID`);
                    return productId;
                }
            }
        }

        log(`❌ Could not find variant ID for product ${productId}`);
        return null;
    }

    // Get conflicting bundle names for contextual messaging
    function getConflictingBundleNames(currentBundle, validationResult) {
        if (!validationResult.bundle_validations || !currentBundle.primary_conflict) {
            return [];
        }

        const currentConflictComponent = currentBundle.primary_conflict.component;
        const conflictingBundles = [];

        validationResult.bundle_validations.forEach(validation => {
            if (!validation.is_valid &&
                validation.product_id !== currentBundle.product_id &&
                validation.primary_conflict &&
                validation.primary_conflict.component === currentConflictComponent) {

                // Extract clean bundle name (remove size/variant info)
                const cleanName = validation.bundle_title.replace(/\s*-\s*[^-]*$/, '').trim();
                conflictingBundles.push(cleanName);
            }
        });

        return conflictingBundles;
    }

    // Generate actionable conflict message
    function generateConflictMessage(bundle, validationResult) {
        const conflictingBundles = getConflictingBundleNames(bundle, validationResult);
        const currentBundleName = bundle.bundle_title.replace(/\s*-\s*[^-]*$/, '').trim();

        if (conflictingBundles.length === 0) {
            // Only this bundle has the conflict
            return `This set cannot be fulfilled due to insufficient component inventory. Please reduce the quantity to continue.`;
        } else if (conflictingBundles.length === 1) {
            // One other bundle conflicts
            return `${currentBundleName} and ${conflictingBundles[0]} need the same component. Reduce quantity of either set to resolve the conflict.`;
        } else {
            // Multiple bundles conflict
            const otherBundles = conflictingBundles.join(', ');
            return `${currentBundleName}, ${otherBundles} all need the same component. Reduce quantity of any of these sets to resolve the conflict.`;
        }
    }

    // Add notification for a specific bundle line item
    function addLineItemNotification(bundle, validationResult) {
        log(`📦 Adding notification for bundle: ${bundle.bundle_title}`);
        log(`📦 Bundle data:`, { product_id: bundle.product_id, variant_id: bundle.variant_id });

        // Use variant_id directly from API response (much more reliable!)
        const variantId = bundle.variant_id;

        if (!variantId) {
            log('❌ No variant_id provided in bundle validation result:', bundle.bundle_title);
            return;
        }

        log(`🔍 Using variant ID ${variantId} from API response for bundle "${bundle.bundle_title}"`);

        // Try to find the line item by variant ID (since that's what's in data-line-key)
        const lineItemRow = findLineItemRow(bundle.product_id, variantId);
        if (!lineItemRow) {
            log('❌ Could not find line item row for bundle:', bundle.bundle_title);
            return;
        }

        log('✅ Found line item row, adding notification for bundle:', bundle.bundle_title);

        // Skip status indicator - we'll show actionable info in the notification instead

        // Style quantity selectors
        styleQuantitySelectors(lineItemRow, 'oversold');

        // Generate contextual, actionable message
        const contextualMessage = generateConflictMessage(bundle, validationResult);

        // Add detailed inline notification
        const notification = createInlineNotification({
            type: 'error',
            icon: '⚠️',
            title: 'Inventory Conflict',
            message: contextualMessage,
            actions: getBundleNotificationActions(bundle, validationResult)
        });

        insertInlineNotification(lineItemRow, notification);
        log('✅ Inline notification added successfully');
    }

    // Get bundle names that need this component
    function getBundlesNeedingComponent(componentVariantId, validationResult) {
        const needingBundles = [];

        if (validationResult.bundle_validations) {
            validationResult.bundle_validations.forEach(validation => {
                if (!validation.is_valid && validation.primary_conflict) {
                    // Check if this bundle's conflict involves the component
                    // Note: We'd need more detailed component info from the API to make this perfect
                    // For now, we'll use a general message
                    const cleanName = validation.bundle_title.replace(/\s*-\s*[^-]*$/, '').trim();
                    needingBundles.push(cleanName);
                }
            });
        }

        return needingBundles;
    }

    // Add notification for individual component issues
    function addComponentNotification(suggestion, validationResult) {
        const lineItemRow = findLineItemRow(null, suggestion.action_data.variant_id);
        if (!lineItemRow) {
            log('Could not find line item row for component variant:', suggestion.action_data.variant_id);
            return;
        }

        const currentQty = getCurrentQuantityFromCart(suggestion.action_data.variant_id);
        const suggestedQty = suggestion.action_data.suggested;
        const componentTitle = suggestion.action_data.component_title || 'This item';

        // Get bundles that need this component
        const needingBundles = getBundlesNeedingComponent(suggestion.action_data.variant_id, validationResult);

        let message;
        if (needingBundles.length === 0) {
            message = `This item conflicts with set inventory. ${suggestedQty === 0 ? 'Remove this item' : `Reduce to ${suggestedQty}`} to enable set checkout.`;
        } else if (needingBundles.length === 1) {
            message = `This item is needed for ${needingBundles[0]} set. ${suggestedQty === 0 ? 'Remove this item' : `Reduce to ${suggestedQty}`} to enable set checkout.`;
        } else {
            const bundleList = needingBundles.slice(0, 2).join(' and ');
            const extra = needingBundles.length > 2 ? ` and ${needingBundles.length - 2} other set${needingBundles.length > 3 ? 's' : ''}` : '';
            message = `This item is needed for ${bundleList}${extra} sets. ${suggestedQty === 0 ? 'Remove this item' : `Reduce to ${suggestedQty}`} to enable set checkout.`;
        }

        log('Adding component notification for:', componentTitle);

        // Style quantity selectors
        styleQuantitySelectors(lineItemRow, 'limited');

        // Add detailed inline notification
        const notification = createInlineNotification({
            type: 'warning',
            icon: '💡',
            title: 'Bundle Optimization',
            message: message,
            actions: [{
                text: suggestedQty === 0 ? '🗑️ Remove' : `📉 Update to ${suggestedQty}`,
                action: 'reduce_individual',
                data: suggestion.action_data
            }]
        });

        insertInlineNotification(lineItemRow, notification);
    }

    // Find line item row by product ID or variant ID
    function findLineItemRow(productId, variantId) {
        log(`🔍 Looking for line item - Product ID: ${productId}, Variant ID: ${variantId}`);

        // Try multiple strategies to find the row
        let row = null;

        // Strategy 1: data-line-key starts with variant ID (before colon)
        if (variantId) {
            log(`🔍 Strategy 1: Looking for tr[data-line-key^="${variantId}:"]`);
            row = document.querySelector(`tr[data-line-key^="${variantId}:"]`);
            if (row) {
                log('✅ Found row using Strategy 1 (data-line-key prefix match)');
                return row;
            }
        }

        // Strategy 2: Manual search through all rows to extract variant ID from data-line-key
        if (variantId) {
            log(`🔍 Strategy 2: Manual search through rows for variant ${variantId}`);
            const allRows = document.querySelectorAll('tr[data-line-key]');
            for (const r of allRows) {
                const lineKey = r.dataset.lineKey;
                if (lineKey) {
                    // Extract variant ID (part before colon)
                    const extractedVariantId = lineKey.split(':')[0];
                    if (extractedVariantId === String(variantId)) {
                        log(`✅ Found row using Strategy 2 (manual extraction): ${lineKey}`);
                        return r;
                    }
                }
            }
        }

        // Strategy 3: Look for variant ID in input elements with data-line-key
        if (variantId) {
            log(`🔍 Strategy 3: Looking for input elements with variant ${variantId}`);
            const inputs = document.querySelectorAll('input[data-line-key]');
            for (const input of inputs) {
                const lineKey = input.dataset.lineKey;
                if (lineKey && lineKey.startsWith(`${variantId}:`)) {
                    row = input.closest('tr');
                    if (row) {
                        log('✅ Found row using Strategy 3 (input data-line-key)');
                        return row;
                    }
                }
            }
        }

        // Strategy 4: Look for product links (fallback)
        if (productId) {
            log(`🔍 Strategy 4: Looking for product links with ID ${productId}`);
            const productLink = document.querySelector(`a[href*="/products/"][href*="${productId}"]`);
            if (productLink) {
                row = productLink.closest('tr');
                if (row) {
                    log('✅ Found row using Strategy 4 (product links)');
                    return row;
                }
            }
        }

        // Debug - show what's actually in the DOM
        log('❌ Could not find line item row. Debugging DOM structure:');
        const allRows = document.querySelectorAll('tr[data-line-key]');
        log(`📊 Found ${allRows.length} rows with data-line-key:`);
        allRows.forEach((r, i) => {
            const lineKey = r.dataset.lineKey;
            const extractedVariantId = lineKey ? lineKey.split(':')[0] : 'none';
            log(`  Row ${i + 1}: data-line-key="${lineKey}" → variant: ${extractedVariantId}`);
        });

        return null;
    }

    // Add status indicator to product name area
    function addStatusIndicator(lineItemRow, status, text) {
        log(`🏷️ Adding status indicator: ${status} - ${text}`);

        const productLink = lineItemRow.querySelector('.line-item-info a, line-item a');
        log(`🔍 Product link found:`, !!productLink);

        if (productLink && !productLink.querySelector('.line-item-status-indicator')) {
            const indicator = document.createElement('span');
            indicator.className = `line-item-status-indicator ${status}`;
            indicator.textContent = text;
            productLink.parentNode.insertBefore(indicator, productLink.nextSibling);
            log('✅ Status indicator added successfully');
        } else if (!productLink) {
            log('❌ No product link found for status indicator');
            // Try alternative locations
            const lineItemInfo = lineItemRow.querySelector('.line-item-info');
            if (lineItemInfo) {
                const indicator = document.createElement('span');
                indicator.className = `line-item-status-indicator ${status}`;
                indicator.textContent = text;
                indicator.style.display = 'block';
                indicator.style.marginTop = '4px';
                lineItemInfo.appendChild(indicator);
                log('✅ Status indicator added to line-item-info');
            }
        } else {
            log('ℹ️ Status indicator already exists');
        }
    }

    // Style quantity selectors to show status
    function styleQuantitySelectors(lineItemRow, status) {
        const quantitySelectors = lineItemRow.querySelectorAll('.quantity-selector');
        quantitySelectors.forEach(selector => {
            selector.classList.add(`quantity-selector--${status}`);
        });
    }

    // Create inline notification element
    function createInlineNotification(config) {
        const notification = document.createElement('div');
        notification.className = `line-item-inline-notification ${config.type}`;

        let html = `
            <div class="notification-icon">${config.icon}</div>
            <div class="notification-content">
                <div><strong>${config.title}</strong></div>
                <div>${config.message}</div>
        `;

        if (config.actions && config.actions.length > 0) {
            html += '<div class="notification-actions">';
            config.actions.forEach(action => {
                html += `<button class="inline-action-btn" data-action="${action.action}" data-action-data='${JSON.stringify(action.data)}'>${action.text}</button>`;
            });
            html += '</div>';
        }

        html += '</div>';
        notification.innerHTML = html;

        // Attach event listeners to action buttons
        notification.querySelectorAll('.inline-action-btn').forEach(button => {
            button.addEventListener('click', handleInlineAction);
        });

        return notification;
    }

    // Insert inline notification into line item
    function insertInlineNotification(lineItemRow, notification) {
        const lineItemInfo = lineItemRow.querySelector('.line-item-info');
        if (lineItemInfo) {
            lineItemInfo.appendChild(notification);
        }
    }

    // Get notification actions for bundle issues
    function getBundleNotificationActions(bundle, validationResult) {
        const actions = [];

        // Look for bundle-specific suggestions
        if (validationResult.bundle_suggestions) {
            const bundleSuggestion = validationResult.bundle_suggestions.find(s =>
                s.action_data.product_id === bundle.product_id
            );

            if (bundleSuggestion) {
                const currentQty = getCurrentBundleQuantityFromCart(bundle.product_id);
                const suggestedQty = bundleSuggestion.action_data.suggested;

                actions.push({
                    text: suggestedQty === 0 ? 'Remove Bundle' : `Reduce to ${suggestedQty}`,
                    action: 'reduce_bundle',
                    data: bundleSuggestion.action_data
                });
            }
        }

        return actions;
    }

    // Handle inline action button clicks
    async function handleInlineAction(e) {
        e.preventDefault();

        const button = e.target;
        const action = button.dataset.action;
        const actionData = JSON.parse(button.dataset.actionData);

        // Store original button state
        const originalText = button.textContent;
        const originalDisabled = button.disabled;

        button.disabled = true;
        button.textContent = 'Updating...';

        try {
            let result;
            let successMessage;

            switch (action) {
                case 'reduce_individual':
                    result = await updateItemQuantity(actionData.variant_id, actionData.suggested);
                    successMessage = actionData.suggested === 0 ? 'Item removed!' : `Quantity updated to ${actionData.suggested}!`;
                    break;

                case 'reduce_bundle':
                    result = await updateBundleQuantity(actionData.product_id, actionData.suggested);
                    successMessage = actionData.suggested === 0 ? 'Bundle removed!' : `Bundle quantity updated to ${actionData.suggested}!`;
                    break;

                default:
                    throw new Error(`Unknown action: ${action}`);
            }

            if (result) {
                // Show success state
                button.textContent = '✓ Done';
                button.style.background = '#059669';
                button.style.borderColor = '#059669';
                button.style.color = 'white';

                // Re-validate cart after changes
                setTimeout(validateCart, 500);
            }

        } catch (error) {
            log('❌ Inline action failed:', error);

            // Restore button state
            button.disabled = originalDisabled;
            button.textContent = originalText;
            button.style.background = '';
            button.style.borderColor = '';
            button.style.color = '';

            // Show error feedback
            button.textContent = '❌ Failed';
            setTimeout(() => {
                button.textContent = originalText;
            }, 2000);
        }
    }

    // Show enhanced validation errors with conflict grouping and enhanced feedback
    function showEnhancedErrors(validationResult) {
        const container = getErrorContainer();

        if (!validationResult || !validationResult.bundle_validations || validationResult.bundle_validations.length === 0) {
            container.style.display = 'none';
            return;
        }

        const invalidBundles = validationResult.bundle_validations.filter(v => !v.is_valid);

        if (invalidBundles.length === 0) {
            container.style.display = 'none';
            return;
        }

        // Group conflicts by component for better UX
        const conflictGroups = groupConflictsByComponent(validationResult);

        let html = '<div class="inventory-issues">';
        html += '<h4>⚠️ Inventory Conflict</h4>';

        // Add general notice at the top
        html += '<div class="general-notice">';
        html += '<p>Insufficient inventory for current quantities. Please reduce or remove items using the cart controls above.</p>';
        html += '</div>';

        log('Conflict groups found:', conflictGroups.length);
        log('Invalid bundles:', invalidBundles.length);

        // Show conflict groups with enhanced feedback
        if (conflictGroups.length > 0) {
            log('Rendering conflict groups');
            html += '<div class="conflict-groups">';
            conflictGroups.forEach(group => {
                html += renderConflictGroup(group);
            });
            html += '</div>';
        } else {
            // Fallback to individual bundle display
            log('No conflict groups, falling back to individual bundle display');
            html += '<div class="bundle-issues">';
            invalidBundles.forEach(bundle => {
                html += renderBundleInfo(bundle, true);
            });
            html += '</div>';
        }

        // Show suggestions with enhanced feedback
        const hasGlobalSuggestions = validationResult.global_suggestions && validationResult.global_suggestions.length > 0;
        const hasBundleSuggestions = validationResult.bundle_suggestions && validationResult.bundle_suggestions.length > 0;

        if (hasGlobalSuggestions) {
            html += '<div class="global-suggestions">';
            html += '<h5>💡 Quick Fixes - Free up inventory:</h5>';
            validationResult.global_suggestions.forEach(suggestion => {
                html += renderEnhancedGlobalSuggestion(suggestion, validationResult);
            });
            html += '</div>';
        } else if (hasBundleSuggestions) {
            html += '<div class="bundle-suggestions">';
            html += '<h5>💡 Bundle Adjustments:</h5>';
            validationResult.bundle_suggestions.forEach(suggestion => {
                html += renderEnhancedBundleSuggestion(suggestion, validationResult);
            });
            html += '</div>';
        }

        html += '</div>';
        container.innerHTML = html;
        container.style.display = 'block';

        // Attach event listeners to action buttons
        attachActionListeners(container, validationResult);

        // Add inline notifications to line items
        addInlineNotifications(validationResult);

        log('Enhanced errors displayed for', invalidBundles.length, 'bundles with',
            (validationResult.global_suggestions?.length || 0) + (validationResult.bundle_suggestions?.length || 0), 'suggestions');
    }

    // Legacy function for backward compatibility
    function showErrors(bundles) {
        // Convert old format to new format for compatibility
        const validationResult = {
            bundle_validations: bundles || [],
            global_suggestions: [],
            bundle_suggestions: []
        };
        showEnhancedErrors(validationResult);
    }

    // Hide errors
    function hideErrors() {
        const container = getErrorContainer();
        container.style.display = 'none';

        // Also clear inline notifications
        clearInlineNotifications();
    }

    // Control checkout buttons
    function setCheckoutState(enabled, customMessage = null) {
        const selectors = [
            'input[name="add"]',
            'button[name="add"]',
            'button[name="checkout"]',
            '.btn--checkout',
            '.cart__checkout-button',
            '.checkout-button',
            '.button[name="checkout"]',
            '.cart-recap .button',
            '[data-checkout-button]'
        ];

        selectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(button => {
                if (enabled) {
                    // Enable checkout
                    button.disabled = false;
                    button.style.opacity = '';
                    button.style.cursor = '';

                    if (button.dataset.originalText) {
                        button.textContent = button.dataset.originalText;
                        delete button.dataset.originalText;
                    }
                } else {
                    // Disable checkout
                    if (!button.dataset.originalText) {
                        button.dataset.originalText = button.textContent;
                    }

                    button.disabled = true;
                    button.style.opacity = '0.5';
                    button.style.cursor = 'not-allowed';
                    button.textContent = customMessage || 'Resolve Cart Issue(s) to Proceed';
                }
            });
        });

        log('Checkout', enabled ? 'enabled' : 'disabled', customMessage ? `(${customMessage})` : '');
    }

    // Main validation function - NO CACHING
    async function validateCart() {
        if (isValidating) {
            log('Already validating, please wait...');
            return;
        }

        isValidating = true;
        log('🔍 Validating cart (fresh check)...');

        try {
            // Always get fresh cart data
            const cartResponse = await fetch('/cart.js?' + Date.now());

            if (!cartResponse.ok) {
                throw new Error(`Cart fetch error: ${cartResponse.status}`);
            }

            const cart = await cartResponse.json();

            log('📦 Cart items:', cart.items.length);
            log('🛒 Cart data:', cart);

            // Check if cart is empty - no validation needed
            if (!cart.items || cart.items.length === 0) {
                log('🛒 Empty cart - no validation needed');
                hideErrors();
                setCheckoutState(true);
                return;
            }

            // Always call API (no caching)
            log('🌐 Calling validation API...');
            const apiResponse = await fetch(CONFIG.apiEndpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(cart)
            });

            if (!apiResponse.ok) {
                throw new Error(`API error: ${apiResponse.status}`);
            }

            const result = await apiResponse.json();
            log('✅ API response:', result);

            // Process validation result
            log('🔍 Processing result status:', result.status);
            log('🔍 Bundle validations:', result.bundle_validations);

            if (result.status === 'success') {
                if (result.bundle_validations && result.bundle_validations.length > 0) {
                    const invalidBundles = result.bundle_validations.filter(v => !v.is_valid);

                    log('📊 Total bundles:', result.bundle_validations.length);
                    log('📊 Invalid bundles:', invalidBundles.length);

                    if (invalidBundles.length > 0) {
                        log('❌ Validation FAILED - oversell detected:', invalidBundles);
                        showEnhancedErrors(result);
                        setCheckoutState(false);
                    } else {
                        log('✅ Validation PASSED - all bundles valid');
                        hideErrors();
                        setCheckoutState(true);
                    }
                } else {
                    log('ℹ️ No bundles to validate');
                    hideErrors();
                    setCheckoutState(true);
                }
            } else {
                log('⚠️ API returned non-success status:', result.status);
                // Fail open on API errors
                hideErrors();
                setCheckoutState(true);
            }

        } catch (error) {
            log('🚨 Validation error (failing open):', error);
            // Fail open - allow checkout on error
            hideErrors();
            setCheckoutState(true);
        } finally {
            isValidating = false;
            log('🏁 Validation complete');
        }
    }

    // Set up event listeners
    function setupListeners() {
        // Intercept fetch requests to detect failed cart updates
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            const url = args[0];

            // Check if this is a cart update request
            if (typeof url === 'string' && (
                url.includes('/cart/change') ||
                url.includes('/cart/update') ||
                url.includes('/cart/add')
            )) {
                log('🔄 Cart update request detected:', url);

                return originalFetch.apply(this, args).then(response => {
                    if (response.status === 422) {
                        log('❌ Cart update failed (422) - Shopify rejected the change');
                        log('⏭️ Skipping validation since cart didn\'t change');
                        // Don't validate - cart update was rejected by Shopify
                    } else if (response.ok) {
                        log('✅ Cart update successful - validating...');
                        setTimeout(validateCart, 500);
                    } else {
                        log(`⚠️ Cart update returned ${response.status} - validating anyway`);
                        setTimeout(validateCart, 500);
                    }

                    return response;
                }).catch(error => {
                    log('❌ Cart update request failed:', error);
                    // Still validate in case of network errors
                    setTimeout(validateCart, 1000);
                    throw error;
                });
            }

            return originalFetch.apply(this, args);
        };

        // Quantity input changes (backup method)
        document.addEventListener('change', function (e) {
            if (e.target.name && (
                e.target.name.includes('quantity') ||
                e.target.name.includes('updates')
            )) {
                log('📝 Quantity input changed, validating...');
                setTimeout(validateCart, 1500); // Longer delay to let fetch intercept handle it first
            }
        });

        // Form submissions (backup method)
        document.addEventListener('submit', function (e) {
            if (e.target.action && e.target.action.includes('/cart')) {
                log('📤 Cart form submitted, validating after...');
                setTimeout(validateCart, 2000); // Longer delay for form submissions
            }
        });

        // Page visibility change (user returns to tab/page)
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) {
                log('👁️ Page became visible - re-validating cart');
                setTimeout(validateCart, 500);
            }
        });

        // Window focus (user returns to window)
        window.addEventListener('focus', function () {
            log('🎯 Window focused - re-validating cart');
            setTimeout(validateCart, 500);
        });

        log('👂 Event listeners active (with 422 detection, visibility, and focus)');
    }

    // Initialize
    function init() {
        log('🚀 Initializing Bundle Cart Validator v2...');

        // Immediately disable checkout until validation completes (prevent refresh bypass)
        setCheckoutState(false, 'Checking inventory...');

        // Initial validation with timeout fallback
        const validationTimeout = setTimeout(() => {
            log('⏰ Validation timeout - failing open');
            hideErrors();
            setCheckoutState(true);
        }, 3000); // 3 second timeout

        validateCart().finally(() => {
            clearTimeout(validationTimeout);
        });

        // Set up listeners
        setupListeners();

        log('✨ Bundle Cart Validator v2 ready');
    }

    // Start when ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Group conflicts by component for better UX
    function groupConflictsByComponent(validationResult) {
        const groups = new Map();

        if (!validationResult.bundle_validations) {
            log('No bundle validations found for grouping');
            return [];
        }

        log('Grouping conflicts for', validationResult.bundle_validations.length, 'bundles');

        validationResult.bundle_validations
            .filter(v => !v.is_valid)
            .forEach(bundle => {
                log('Processing bundle:', bundle.bundle_title, 'Conflict:', bundle.primary_conflict);

                if (bundle.primary_conflict) {
                    // Try multiple ways to extract component name from conflict
                    let componentKey = 'Unknown Component';

                    // Method 1: Direct component_title
                    if (bundle.primary_conflict.component_title) {
                        componentKey = bundle.primary_conflict.component_title;
                    }
                    // Method 2: Extract from description (e.g., "LC4 component oversold")
                    else if (bundle.primary_conflict.description) {
                        const match = bundle.primary_conflict.description.match(/^([^\\s]+)\\s+component/i);
                        if (match) {
                            componentKey = match[1];
                        } else {
                            // Fallback: use first word of description
                            const firstWord = bundle.primary_conflict.description.split(' ')[0];
                            if (firstWord && firstWord.length > 1) {
                                componentKey = firstWord;
                            }
                        }
                    }
                    // Method 3: Check if there's a component_sku or similar
                    else if (bundle.primary_conflict.component_sku) {
                        componentKey = bundle.primary_conflict.component_sku;
                    }

                    log('Extracted component key:', componentKey, 'for bundle:', bundle.bundle_title);

                    if (!groups.has(componentKey)) {
                        groups.set(componentKey, {
                            component: componentKey,
                            conflict: bundle.primary_conflict,
                            bundles: []
                        });
                    }

                    groups.get(componentKey).bundles.push(bundle);
                } else {
                    log('No primary conflict found for bundle:', bundle.bundle_title);
                }
            });

        const groupArray = Array.from(groups.values());
        log('Created', groupArray.length, 'conflict groups:', groupArray.map(g => `${g.component} (${g.bundles.length} bundles)`));

        return groupArray;
    }

    // Render conflict group with enhanced feedback
    function renderConflictGroup(group) {
        log('Rendering conflict group:', group.component, 'with', group.bundles.length, 'bundles');

        let html = `<div class="conflict-group">`;

        // Group header with concise message
        html += `<div class="conflict-group-header">`;
        html += `${group.bundles.length} set${group.bundles.length > 1 ? 's' : ''} share a component`;
        html += `</div>`;

        // Affected bundles
        html += `<div class="affected-bundles">`;
        group.bundles.forEach(bundle => {
            // Extract main title and variation
            const titleParts = bundle.bundle_title.split(' - ');
            const mainTitle = titleParts[0] || bundle.bundle_title;
            const variation = titleParts.slice(1).join(' - ');

            html += `<div class="affected-bundle">`;
            html += `<div class="bundle-name">${mainTitle}</div>`;
            if (variation) {
                html += `<div class="bundle-variation">${variation}</div>`;
            }
            // Hide technical conflict details for cleaner display
            html += `</div>`;
        });
        html += `</div>`;

        html += `</div>`;
        return html;
    }

    // Render bundle information with conflict details
    function renderBundleInfo(bundle, showComponentDetails = true) {
        // Extract main title and variation
        const titleParts = bundle.bundle_title.split(' - ');
        const mainTitle = titleParts[0] || bundle.bundle_title;
        const variation = titleParts.slice(1).join(' - ');

        let html = `<div class="bundle-issue" data-product-id="${bundle.product_id}">`;
        html += `<div class="bundle-main-title">${mainTitle}</div>`;

        if (variation) {
            html += `<div class="bundle-variation">${variation}</div>`;
        }

        // Hide technical conflict details for cleaner display
        // Individual line items will show the actionable messages instead

        html += '</div>';
        return html;
    }

    // Render enhanced global suggestion with impact preview
    function renderEnhancedGlobalSuggestion(suggestion, validationResult) {
        const currentQty = getCurrentQuantityFromCart(suggestion.action_data.variant_id);
        const suggestedQty = suggestion.action_data.suggested;
        const reduction = currentQty - suggestedQty;

        // Calculate impact
        const affectedBundles = getAffectedBundlesForComponent(suggestion, validationResult);

        let html = `<div class="suggestion-enhanced">`;
        html += `<div class="suggestion-header">`;
        html += `<div class="suggestion-main">`;
        html += `<div class="suggestion-title">`;
        html += `<span class="quantity-context">Reduce ${suggestion.action_data.component_title || 'Component'} </span>`;
        html += `<span class="quantity-change">from ${currentQty} to ${suggestedQty}</span>`;
        html += `</div>`;
        if (affectedBundles.length > 0) {
            html += `<div class="suggestion-impact">`;
            html += `✓ Will enable ${affectedBundles.length} bundle${affectedBundles.length > 1 ? 's' : ''} to checkout`;
            html += `</div>`;
        }
        html += `</div>`;
        html += `<button class="action-btn update-qty" data-action="${suggestion.type}" 
            data-variant="${suggestion.action_data.variant_id}"
            data-quantity="${suggestedQty}"
            data-current="${currentQty}">
            ${suggestedQty === 0 ? 'Remove' : `Update to ${suggestedQty}`}
        </button>`;
        html += `</div>`;

        if (reduction > 0) {
            html += `<div class="impact-preview">`;
            html += `💡 Reducing by ${reduction} unit${reduction > 1 ? 's' : ''} will free up inventory for bundle checkout`;
            html += `</div>`;
        }

        html += `</div>`;
        return html;
    }

    // Render enhanced bundle suggestion with impact preview
    function renderEnhancedBundleSuggestion(suggestion, validationResult) {
        const bundle = validationResult.bundle_validations.find(b =>
            b.product_id === suggestion.action_data.product_id
        );
        const bundleTitle = bundle ? bundle.bundle_title : 'Bundle';
        const currentQty = getCurrentBundleQuantityFromCart(suggestion.action_data.product_id);
        const suggestedQty = suggestion.action_data.suggested;
        const reduction = currentQty - suggestedQty;

        let html = `<div class="suggestion-enhanced">`;
        html += `<div class="suggestion-header">`;
        html += `<div class="suggestion-main">`;
        html += `<div class="suggestion-title">`;
        html += `<span class="quantity-context">Reduce ${bundleTitle} </span>`;
        html += `<span class="quantity-change">from ${currentQty} to ${suggestedQty}</span>`;
        html += `</div>`;
        html += `<div class="suggestion-impact">`;
        html += `✓ Will resolve inventory conflicts for this bundle`;
        html += `</div>`;
        html += `</div>`;
        html += `<button class="action-btn update-qty" data-action="${suggestion.type}" 
            data-product="${suggestion.action_data.product_id}"
            data-quantity="${suggestedQty}"
            data-current="${currentQty}">
            ${suggestedQty === 0 ? 'Remove Bundle' : `Update to ${suggestedQty}`}
        </button>`;
        html += `</div>`;

        if (reduction > 0) {
            html += `<div class="impact-preview">`;
            html += `💡 Reducing by ${reduction} bundle${reduction > 1 ? 's' : ''} will resolve the inventory conflict`;
            html += `</div>`;
        }

        html += `</div>`;
        return html;
    }

    // Legacy functions for backward compatibility
    function renderGlobalSuggestion(suggestion) {
        return renderEnhancedGlobalSuggestion(suggestion, {});
    }

    function renderBundleSuggestion(suggestion) {
        return renderEnhancedBundleSuggestion(suggestion, {});
    }

    // Cart update functions
    async function updateItemQuantity(variantId, newQuantity) {
        const updates = {};
        updates[variantId] = newQuantity;
        return await updateCart(updates);
    }

    async function updateBundleQuantity(productId, newQuantity) {
        const updates = {};
        updates[productId] = newQuantity;
        return await updateCart(updates);
    }

    async function updateCart(updates) {
        const formData = new FormData();
        formData.append('updates', JSON.stringify(updates));

        const response = await fetch('/cart/update.js', {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error(`Cart update failed: ${response.status}`);
        }

        return response.json();
    }

    // Show success message
    function showSuccessMessage(message) {
        const container = getErrorContainer();
        container.innerHTML = `<div class="success-message">✅ ${message}</div>`;
        container.style.background = '#d4edda';
        container.style.borderColor = '#c3e6cb';
        container.style.color = '#155724';
        container.style.display = 'block';

        // Hide success message after 3 seconds
        setTimeout(() => {
            container.style.display = 'none';
        }, 3000);
    }

    // Show error message
    function showErrorMessage(message) {
        const container = getErrorContainer();
        container.innerHTML = `<div class="error-message">❌ ${message}</div>`;
        container.style.background = '#f8d7da';
        container.style.borderColor = '#f5c6cb';
        container.style.color = '#721c24';
        container.style.display = 'block';
    }

    // Attach event listeners to action buttons with enhanced feedback
    function attachActionListeners(container, validationResult) {
        container.querySelectorAll('.action-btn').forEach(button => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();

                const action = button.dataset.action;
                const variantId = button.dataset.variant;
                const productId = button.dataset.product;
                const quantity = parseInt(button.dataset.quantity);
                const currentQty = parseInt(button.dataset.current) || 1;

                // Store original button state
                const originalText = button.textContent;
                const originalDisabled = button.disabled;

                // Enhanced loading state with context
                button.disabled = true;
                if (quantity === 0) {
                    button.textContent = 'Removing...';
                } else if (quantity < currentQty) {
                    button.textContent = `Reducing to ${quantity}...`;
                } else {
                    button.textContent = 'Updating...';
                }

                try {
                    let result;
                    let successMessage;

                    switch (action) {
                        case 'reduce_individual':
                            result = await updateItemQuantity(variantId, quantity);
                            if (quantity === 0) {
                                successMessage = 'Item removed from cart!';
                            } else {
                                const reduction = currentQty - quantity;
                                successMessage = `Quantity reduced by ${reduction} - inventory freed for bundles!`;
                            }
                            break;

                        case 'reduce_bundle':
                            result = await updateBundleQuantity(productId, quantity);
                            if (quantity === 0) {
                                successMessage = 'Bundle removed from cart!';
                            } else {
                                const reduction = currentQty - quantity;
                                successMessage = `Bundle quantity reduced by ${reduction} - conflict resolved!`;
                            }
                            break;

                        default:
                            throw new Error(`Unknown action: ${action}`);
                    }

                    if (result) {
                        // Enhanced success feedback
                        showSuccessMessage(successMessage);

                        // Update button to show completion
                        button.textContent = '✓ Done';
                        button.style.background = '#059669';

                        // Re-validate cart after changes
                        setTimeout(validateCart, 500);
                    } else {
                        throw new Error('Cart update returned no result');
                    }

                } catch (error) {
                    log('❌ Action failed:', error);

                    // Enhanced error feedback
                    let errorMessage = 'Failed to update cart. ';
                    if (error.message.includes('422')) {
                        errorMessage += 'Invalid quantity - please check your cart.';
                    } else if (error.message.includes('network')) {
                        errorMessage += 'Network error - please try again.';
                    } else {
                        errorMessage += 'Please try again or use cart controls above.';
                    }

                    showErrorMessage(errorMessage);

                    // Restore button state
                    button.disabled = originalDisabled;
                    button.textContent = originalText;
                }
            });
        });
    }

    // Helper functions for enhanced feedback
    function getCurrentQuantityFromCart(variantId) {
        // Try to get from last known cart data or make a best guess
        try {
            const cartItems = document.querySelectorAll('[data-variant-id="' + variantId + '"]');
            if (cartItems.length > 0) {
                const qtyInput = cartItems[0].querySelector('input[name*="quantity"], input[name*="updates"]');
                if (qtyInput) {
                    return parseInt(qtyInput.value) || 0;
                }
            }
        } catch (e) {
            log('Could not determine current quantity for variant', variantId);
        }
        return 1; // Default fallback
    }

    function getCurrentBundleQuantityFromCart(productId) {
        // Try to get from cart data or make a best guess
        try {
            const cartItems = document.querySelectorAll('[data-product-id="' + productId + '"]');
            if (cartItems.length > 0) {
                const qtyInput = cartItems[0].querySelector('input[name*="quantity"], input[name*="updates"]');
                if (qtyInput) {
                    return parseInt(qtyInput.value) || 0;
                }
            }
        } catch (e) {
            log('Could not determine current quantity for product', productId);
        }
        return 1; // Default fallback
    }

    function getAffectedBundlesForComponent(suggestion, validationResult) {
        if (!validationResult.bundle_validations) return [];

        const componentTitle = suggestion.action_data.component_title;
        if (!componentTitle) return [];

        return validationResult.bundle_validations.filter(bundle =>
            !bundle.is_valid &&
            bundle.primary_conflict &&
            bundle.primary_conflict.component_title === componentTitle
        );
    }

    // Debug interface
    window.BundleValidator = {
        validate: validateCart,
        enableDebug: () => { CONFIG.debugMode = true; },
        disableDebug: () => { CONFIG.debugMode = false; },
        isValidating: () => isValidating
    };

})();